// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__y9LoS","head":"Table_head__zoadf","col":"Table_col__1Npn0"};